module.exports = __webpack_public_path__ + "img/lc.c2c6b5f0.svg";